module.exports = __webpack_public_path__ + "img/cloth_g2_item_18.f7eb44bb.svg";